module.exports = __webpack_public_path__ + "static/media/doodle-iphone-app.e7db75f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/mobile/doodle-iphone-app.svg
// module id = 1516
// module chunks = 49